// public/js/modules/map.js
// Re-exports for the MapLibre map module

export * from './map/state.js';
export * from './map/constants.js';
export * from './map/core.js';
export * from './map/markers.js';  // includes showAssetPopup
export * from './map/clustering.js';
export * from './map/rendering.js';
export * from './map/history.js';
export * from './map/info-panel.js';
export * from './map/trail-events.js';

// Also re-export simplify helpers
export {
  simplifyRoute,
  findStopIndices,
  SIMPLIFICATION
} from './map/simplify.js';

// Convenience default export
import * as mapModule from './map/index.js';
export default mapModule;
